<template>
  <div class="page">
    <!-- 顶部导航 -->
    <header class="header">
      <div class="container header-inner">
        <div class="logo-wrap">
          <img class="logo" src="@/assets/text-logo.png" alt="logo" />
          <!-- PC 導航 -->
          <nav class="nav pc-only">
            <a href="#about">关于我們</a>
            <a href="#services">联系我們</a>
            <a href="#contact">加入我們</a>
          </nav>
        </div>
        <!-- 右上角電話 -->
        <div class="tel pc-only">
         
          <a href="https://tkzl.zhonglianhuashu.com/marketing-client/auth/login" target="_blank" rel="noopener noreferrer">会员登录</a>
        </div>

        <!-- 移動端菜單 -->
        <div class="mobile-menu-toggle mobile-only" @click="menuOpen = !menuOpen"><span></span><span></span><span></span></div>
      </div>

      <!-- 移動端下拉菜單 -->
      <transition name="fade">
        <nav class="nav mobile-nav mobile-only" v-if="menuOpen">
          <a href="#services" @click="closeMenu">解決方案</a>
          <a href="#business" @click="closeMenu">核心業務</a>
          <a href="#about" @click="closeMenu">關於我們</a>
          <a href="#contact" @click="closeMenu">加入我們</a>
        </nav>
      </transition>
    </header>

    <!-- 首屏 Hero 區 -->
    <section class="hero">
      <div class="container hero-inner">
        <div class="bannerTop">
          <div class="hero-text">
            <h1>让投放更<span class="highlight">智能</span>，让增长更确定</h1>
            <p class="hero-sub">以技术与数据驱动营销效率，为品牌提供高效、透明、可持续的广告投放服务</p>
          </div>
          <img class="bannerImg" src="@/assets/banner.png" alt="" />
        </div>
        <div class="cardSection">
          <div class="cardItem" v-for="(item, index) in stats" :key="index">
            <img :src="item.icon" class="icon" alt="" />
            <div class="descSection">
              <div class="title">{{ item.title1 }}</div>
              <div class="desc">{{ item.desc1 }}</div>
            </div>
            <div class="descSection">
              <div class="title">{{ item.title2 }}</div>
              <div class="desc">{{ item.desc2 }}</div>
            </div>
          </div>
        </div>
      </div>
    </section>

    <!-- 關於我們 -->
    <section class="section about" id="about">
      <div class="container">
        <div class="section-header">
          <img :src="gywm" alt="" />
        </div>
        <div class="about-inner">
          <div class="about-text">
            <img :src="aboutIcon" alt="" class="aboutIcon" />
            <div class="aboutDetail">
              <div class="title">厦门市二叉链科技有限公司</div>
              <div class="desc">专注于数字广告投放，通过技术、数据与行业经验为品牌提供高效可靠的增长方案。</div>
              <div class="line"></div>
              <div class="title">深度整合主流媒体平台资源</div>
              <div class="desc">通过自研的数据分析与投放管理工具，实现跨平台的统一投放、智能优化与效果可视化。</div>
              <div class="line"></div>
              <div class="desc">作为二级广告代理商，我们以 精准、高效、透明 为核心服务原则，让广告投放更可控，让品牌增长更确定。</div>
            </div>
            <!-- <button class="btn-primary sm">聯絡我們</button> -->
          </div>
        </div>
      </div>
    </section>

    <!-- 四個統計卡片 -->
    <!-- <section class="stats" id="services">
      <div class="container stats-grid">
        <div class="stat-card" :class="index % 2 === 1 ? 'stat-card1' : 'stat-card0'" v-for="(item, index) in stats" :key="item.title">
          <div class="left">
            <img :src="item.icon" class="icon" alt="" />
            <div class="desc">
              <div class="stat-number">{{ item.number }}</div>
              <div class="stat-desc">{{ item.desc }}</div>
            </div>
          </div>
          <img :src="item.img" class="descImg" alt="" />
        </div>
      </div>
    </section> -->

    <!-- 核心業務 -->
    <section class="section" id="business">
      <div class="container">
        <div class="section-header">
          <img :src="hxnl" alt="" />
        </div>
        <div class="card-grid">
          <div class="business-card" v-for="item in business" :key="item.title">
            <div class="imgBox">
              <img :src="item.img" class="icon" alt="icon" />
            </div>

            <h3>{{ item.title }}</h3>
            <p>{{ item.desc }}</p>
          </div>
        </div>
      </div>
    </section>

    <!-- 服务项目 -->
    <section class="section serviceSection" id="serviceSection">
      <div class="container">
        <div class="section-header">
          <img :src="fwxm" class="titleImg" alt="" />
        </div>
        <div class="service-card-grid">
          <div class="service-card" v-for="item in service" :key="item.title">
            <div class="imgBox">
              <img :src="item.icon" :class="`icon${index}`" alt="icon" />
            </div>
            <div class="descBox">
              <div class="title">{{ item.title }}</div>
              <div class="desc">{{ item.desc }}</div>
            </div>
          </div>
        </div>
      </div>
    </section>

    <!-- 使命愿景 -->
    <section class="section missionSection" id="missionSection">
      <div class="container">
        <div class="section-header">
          <img :src="smyj" class="titleImg" alt="" />
        </div>
        <div class="mission-card-grid">
          <div class="left">
            <div class="title">使命 Mission</div>
            <div class="desc">用技术与数据提升广告投放效率，为品牌带来可持续的增长力。</div>
            <div class="title">愿景 Vision</div>
            <div class="desc">成为行业领先的智能化广告投放服务公司，让营销更透明、更高效、更智能。</div>
          </div>
          <div class="right">
            <div class="rightTop">
              价值观 Values
            </div>
            <div class="rightBottom">
              <div class="item item0">
                <div class="zh">智能</div>
                <div class="en">Intelligence</div>
              </div>
              <div class="item item1">
                <div class="zh">精准</div>
                <div class="en">Precision</div>
              </div>
              <div class="item item2">
                <div class="zh">透明</div>
                <div class="en">Transparency</div>
              </div>
              <div class="item item3">
                <div class="zh">专业</div>
                <div class="en">Expertise</div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>

    <!-- 聯繫 & 底部 -->
    <Footer />
  </div>
</template>

<script>
import icon0 from '@/assets/icon0.svg'
import icon1 from '@/assets/icon1.svg'
import icon2 from '@/assets/icon2.svg'
import hxnl from '@/assets/hxnl.png'
import fwxm from '@/assets/fwxm.png'
import smyj from '@/assets/smyj.png'
import yewu0 from '@/assets/yewu0.png'
import yewu1 from '@/assets/yewu1.png'
import yewu2 from '@/assets/yewu2.png'
import yewu3 from '@/assets/yewu3.png'
import fw0 from '@/assets/fw0.svg'
import fw1 from '@/assets/fw1.svg'
import fw2 from '@/assets/fw2.svg'
import fw3 from '@/assets/fw3.svg'
import fw4 from '@/assets/fw4.svg'
import fw5 from '@/assets/fw5.svg'
import gywm from '@/assets/aboutUs.png'
import aboutIcon from '@/assets/aboutIcon.svg'
import aboutBg from '@/assets/aboutBg.png'
import Footer from '@/components/footer'
export default {
  name: 'App',
  components: { Footer },
  data() {
    return {
      menuOpen: false,
      hxnl,
      gywm,
      fwxm,
      smyj,
      aboutIcon,
      aboutBg,
      stats: [
        {
          title1: '• 技术加持',
          desc1: '累計服務客戶',
          icon: icon0,
          title2: '• 数据驱动',
          desc2: '决策更精准更可控'
        },
        {
          title1: '• 行业经验足',
          desc1: '覆盖核心消费行业',
          icon: icon1,
          title2: '• 资源丰富',
          desc2: '多平台渠道深度整合'
        },
        {
          title1: '• 过程透明',
          desc1: '效果清晰可追踪',
          icon: icon2,
          title2: '• 执行稳定',
          desc2: '专业团队全程服务'
        }
      ],
      business: [
        {
          title: '智能化投放系统支持',
          desc: '自研数据平台支持跨平台数据融合、预算自动分配、实时监测和投放效果预测。 让每一次决策更科学，每一步优化更及时。',
          img: yewu0
        },
        {
          title: '多平台資源整合',
          desc: '覆盖主流内容平台、电商平台和效果广告渠道，构建统一管理与协同优化体系。 让品牌获得更高质量的流量与更稳定的转化。',
          img: yewu1
        },
        {
          title: '行业经验与数据洞察双驱动',
          desc: '深耕美妆、日化、食品饮料、电商等领域，基于行业趋势与数据洞察制定投放策略。 让广告投放更贴合市场，更符合用户需求。',
          img: yewu2
        },
        {
          title: '全链路广告投放服务体系',
          desc: '从策略制定、账户管理到效果监测和复盘分析，全流程透明可视化。 通过数据闭环持续优化投放效果，实现稳定增长。',
          img: yewu3
        }
      ],
      service: [
        {
          icon: fw0,
          title: '多平台广告投放管理',
          desc: '覆盖多类媒体渠道，构建统一投放策略，实现跨平台一致性与协同效应。通过素材测试、定向管理与节奏控制，提升曝光效率与转化表现。'
        },
        {
          icon: fw1,
          title: '投放策略与预算规划',
          desc: '基于数据模型制定可量化的投放策略，提供完整预算拆解与节奏规划。通过ROI预估与实时调整，实现预算产出最大化。'
        },
        {
          icon: fw2,
          title: '账户托管与日常优化',
          desc: '提供全流程账户托管，包含创意管理、出价策略、人群调优与数据复盘。每日监控投放表现，快速定位问题并执行优化闭环。'
        },
        {
          icon: fw3,
          title: '数据分析与效果监测',
          desc: '通过自研分析系统对数据进行可视化拆解，对曝光、点击、成本、转化等关键指标进行监测。支持异常预警与投放归因，帮助企业精准判断投放价值。'
        },
        {
          icon: fw4,
          title: '人群洞察与模型分析',
          desc: '整合人群标签、用户行为与转化数据，构建高效人群分层模型。精准锁定核心人群，实现更高的触达效率与转化率。'
        },
        {
          icon: fw5,
          title: '跨平台整合与协同投放',
          desc: '打通多个媒体渠道的数据链路，实现策略统一、素材协同与效果联动。最大化利用媒体间差异优势，提升整体投放效果。'
        }
      ]
    }
  },
  methods: {
    closeMenu() {
      this.menuOpen = false
    }
  }
}
</script>

<style scoped>
/* 基礎樣式 */
* {
  box-sizing: border-box;
}

.page {
  font-family: -apple-system, BlinkMacSystemFont, 'PingFang TC', 'Microsoft JhengHei', 'Helvetica Neue', Arial, sans-serif;
  color: #1f2933;
  background: #fff;
}

a {
  text-decoration: none;
  color: inherit;
}

.container {
  width: 100%;
  max-width: 1220px;
  margin: 0 auto;
  padding: 0 16px;
}

/* ------------------ header ------------------ */

.header {
  position: sticky;
  top: 0;
  z-index: 100;
  background: rgba(255, 255, 255, 0.96);
  backdrop-filter: blur(8px);
  box-shadow: 0 1px 4px rgba(15, 35, 95, 0.06);
}

.header-inner {
  display: flex;
  align-items: center;
  justify-content: space-between;
  height: 64px;
}

.logo-wrap {
  display: flex;
  align-items: center;
  /* flex: 1; */
}

.logo {
  width: 300px;
  margin-right: 80px;
}

.logo-text .title {
  font-size: 14px;
  font-weight: 600;
}

.logo-text .sub {
  font-size: 10px;
  color: #8a94a6;
}

.nav {
  display: flex;
  gap: 24px;
  font-size: 14px;
}

.nav a {
  position: relative;
  padding-bottom: 4px;
}

.nav a::after {
  content: '';
  position: absolute;
  left: 0;
  bottom: 0;
  width: 0;
  height: 2px;
  background: linear-gradient(90deg, #4d7bff, #5fd4ff);
  transition: width 0.2s ease;
}

.nav a:hover::after {
  width: 100%;
}

.tel {
  /* margin-left: 24px; */
  padding: 6px 12px;
  border-radius: 8px;
  /* border: 1px solid #4d7bff; */
  font-size: 13px;
  color: #111;
  background: #e9f2fe;
  display: flex;
  align-items: center;
}
.tel .icon {
  width: 20px;
  margin-right: 5px;
}

/* 移動端菜單按鈕 */
.mobile-menu-toggle {
  width: 24px;
  height: 24px;
  display: flex;
  flex-direction: column;
  justify-content: center;
  gap: 4px;
}

.mobile-menu-toggle span {
  display: block;
  height: 2px;
  border-radius: 999px;
  background: #1f2933;
}

.mobile-nav {
  display: flex;
  flex-direction: column;
  padding: 8px 16px 12px;
  border-top: 1px solid #e5edff;
  background: #ffffff;
}

.mobile-nav a {
  padding: 8px 0;
  font-size: 14px;
}

/* ------------------ hero ------------------ */

.hero {
  position: relative;
  overflow: hidden;
  /* background: radial-gradient(circle at 0 0, #e4f0ff 0, #ffffff 45%, #f1f5ff 100%); */
  /* F7FDF9 */
  /* F3FFFF */
  /* background: linear-gradient(135deg, #f7fdf9, #fff); */
  background-image: url('@/assets/hero-bg.png');
  background-repeat: no-repeat;
  background-size: 100% auto;
}

.hero-bg {
  /* position: absolute;
  inset: 0;
  background-image: url("@/assets/hero-bg.png");
  background-size: cover;
  background-position: center;
  opacity: 0.08;
  pointer-events: none; */
}

.hero-inner {
  position: relative;

  padding: 100px 20px 60px;

  /* background-image: url('@/assets/hero-bg.png');
  background-repeat: no-repeat;
  background-size: 100% auto; */
}
.hero-inner .bannerTop {
  display: flex;
  align-items: center;
  justify-content: space-between;
}
.hero-inner .bannerImg {
  width: 430px;
}
.cardSection {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 20px;
}
.cardSection .cardItem {
  flex: 1;
  height: 150px;
  border-radius: 8px;
  display: flex;
  justify-content: center;
  align-items: center;
  background: linear-gradient(176.45deg, #ffffff -2.3%, #e9f1fe 95.97%);
}

.cardSection .cardItem .icon {
  width: 50px;
  margin-right: 20px;
}
.cardSection .cardItem .title {
  color: #0d0d0e;
  font-weight: 700;
  font-size: 20px;
}
.cardSection .cardItem .desc {
  color: #666666;
  font-size: 12px;
}
.cardSection .cardItem .descSection {
  margin-right: 10px;
}

.cardSection .cardItem .desc {
  color: #666666;
  font-weight: 500;
  font-size: 14px;
  padding-left: 14px;
  margin-top: 3px;
}
.hero-text {
  flex: 3;
  max-width: 640px;
}

.hero-text h1 {
  font-size: 48px;
  line-height: 1.4;
  font-weight: 1000;
  color: #111827;
}

.highlight {
  color: #297eff;
}

.hero-sub {
  margin-top: 10px;
  font-size: 18px;
  font-weight: 800;
  color: #333333;
}

.hero-desc {
  margin-top: 16px;
  font-size: 14px;
  line-height: 1.7;
  color: #4b5563;
}

.hero-actions {
  margin-top: 24px;
  display: flex;
  gap: 12px;
}

.btn-primary,
.btn-ghost {
  min-width: 120px;
  padding: 10px 18px;
  border-radius: 999px;
  border: none;
  cursor: pointer;
  font-size: 14px;
  transition: all 0.15s ease;
}

.btn-primary {
  background: linear-gradient(135deg, #4d7bff, #5fd4ff);
  color: #ffffff;
  box-shadow: 0 10px 25px rgba(77, 123, 255, 0.35);
}

.btn-primary:hover {
  transform: translateY(-1px);
  box-shadow: 0 12px 30px rgba(77, 123, 255, 0.45);
}

.btn-ghost {
  background: #ffffff;
  color: #2760ff;
  border: 1px solid #d0ddff;
}

.btn-ghost:hover {
  background: #f3f6ff;
}

.btn-primary.sm {
  min-width: 104px;
  padding: 8px 16px;
  font-size: 13px;
}

/* 右側大標題區 */
.hero-graphic {
  flex: 2;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
}

.hero-main-text {
  font-size: 40px;
  font-weight: 800;
  letter-spacing: 0.12em;
  background: linear-gradient(135deg, #2e72ff, #5fd4ff);
  -webkit-background-clip: text;
  color: transparent;
  text-shadow: 0 10px 20px rgba(46, 114, 255, 0.45);
}

.hero-chip {
  margin-top: 20px;
  width: 220px;
  height: 120px;
  border-radius: 30px;
  background: radial-gradient(circle at 20% 0, #ffffff 0, #e0ecff 40%, #d1f5ff 100%);
  box-shadow: 0 15px 35px rgba(36, 99, 255, 0.3);
}

/* ------------------ stats ------------------ */

.stats {
  margin-top: 40px;
  padding-bottom: 40px;
}

.stats-grid {
  display: flex;
  align-items: center;
  gap: 16px;
}

.stat-card {
  border-radius: 20px;
  padding: 18px 40px;
  min-width: 380px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  cursor: pointer;
}
.stat-card0 {
  background: linear-gradient(154.24deg, #f0f6ff 1.98%, #e5effe 50.61%, #b7d9fe 100%);
}
.stat-card1 {
  background: linear-gradient(155.55deg, #f2fbff 3.85%, #f3fbff 51.61%, #d7faff 102.64%);
}
.stat-card .left {
  display: flex;
  align-items: center;
}
.stat-card .left .icon {
  margin-right: 20px;
}
.stat-card .descImg {
  width: 80px;
}

.stat-icon {
  width: 40px;
  height: 40px;
  border-radius: 16px;
  background: linear-gradient(135deg, #4d7bff, #5fd4ff);
  opacity: 0.92;
  margin-bottom: 12px;
}

.stat-number {
  font-size: 18px;
  font-weight: 700;
  color: #0d0d0e;
}

.stat-title {
  margin-top: 6px;
  font-size: 14px;
  font-weight: 600;
}

.stat-desc {
  margin-top: 4px;
  font-size: 12px;
  color: #666;
}

/* ------------------ 通用 section ------------------ */

.section {
  padding: 35px 0;
}
.section-header {
  display: flex;
  align-items: center;
  justify-content: center;
  padding-bottom: 50px;
}
.section-header img {
  width: 150px;
  text-align: center;
}

.section-header h2 {
  font-size: 22px;
  font-weight: 700;
}

.section-header p {
  font-size: 12px;
  letter-spacing: 0.15em;
  color: #9ca3af;
}

/* 服务项目 */
.serviceSection {
  background-image: url('@/assets/fwbg.png');
  background-size: 100% 100%;
}
.serviceSection .titleImg {
  width: 120px;
}
.service-card-grid {
  display: flex;
  justify-content: space-between;
  flex-wrap: wrap;
  gap: 10px;
}
.service-card {
  margin-bottom: 10px;
  background: #ffffff;
  border-radius: 20px;
  width: 385px;
  display: flex;
  align-items: flex-start;
  padding: 30px;
}
.service-card img {
  width: 65px;
  margin-right: 10px;
}
.service-card .descBox .title{
  color: #0d0d0e;
  font-size: 20px;
  font-weight: bold;
  margin-bottom: 10px;
}
.service-card .descBox .desc{
  color: #666666;
  font-size: 12px;
  line-height: 18px;
}
/* 使命愿景 */
.mission-card-grid{
  display: flex;
  gap: 10px;
}
.mission-card-grid .left{
  background-image: url('@/assets/smyjBg.png');
  background-size: 100% 100%;
  background-repeat: no-repeat;
  color: #fff;
  width: 420px;
  padding:40px 85px 40px 50px;
  border-radius: 20px;
}
.mission-card-grid .left .title{
  color: #fff;
  font-size: 18px;
  margin-bottom: 12px;
}
.mission-card-grid .left .desc{
  color: rgba(255,255,255,.8);
  font-size: 12px;
  margin-bottom: 12px;
}
.mission-card-grid .right{
  flex: 1;
  color: #1A41E7;
  font-weight: bold;
  display: flex;
  flex-direction: column;
}
.mission-card-grid .right .rightTop{
  width: 100%;
  font-size: 22px;
  text-align: center;
  height: 70px;
  line-height: 70px;
  background-image: url('@/assets/valuesBg.png');
  background-size: 100% 100%;
  background-repeat: no-repeat;
  border-radius: 20px;
}
.mission-card-grid .right .rightBottom{
  display: flex;
  margin-top: 10px;
  gap: 10px;
  flex: 1;
}
.mission-card-grid .right .rightBottom .item{
  flex: 1;
  border-radius: 20px;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: flex-start;
  padding-left: 40px;
  background-size: 100% 100%;
  background-repeat: no-repeat;
}
.mission-card-grid .right .rightBottom .item0{
 background-image: url('@/assets/intelligenceBg.png');;
}
.mission-card-grid .right .rightBottom .item1{
 background-image: url('@/assets/precisionBg.png');;
}
.mission-card-grid .right .rightBottom .item2{
 background-image: url('@/assets/transparencyBg.png');;
}
.mission-card-grid .right .rightBottom .item3{
 background-image: url('@/assets/expertiseBg.png');;
}



/* 核心業務卡片 */
.card-grid {
  display: grid;
  grid-template-columns: repeat(4, minmax(0, 1fr));
  gap: 16px;
}

.business-card {
  background: #f9fbff;
  border-radius: 20px;
  padding: 50px 30px;
  /* box-shadow: 0 8px 18px rgba(15, 35, 95, 0.05); */
  display: flex;
  flex-direction: column;
  align-items: center;
}
.business-card .imgBox {
  width: 120px;
  height: 120px;
  display: flex;
  align-items: center;
  margin-bottom: 60px;
}
.business-card .icon {
  width: 120px;
}

.business-card h3 {
  font-size: 16px;
  color: #0d0d0e;
  margin-bottom: 8px;
}

.business-card p {
  font-size: 12px;
  color: #666;
  line-height: 1.5;
}

/* 關於我們 */
.about {
  /* background: linear-gradient(180deg, #f3f6ff, #ffffff); */
  display: flex;
  flex-direction: column;
  align-items: center;
}
.about .section-header img {
  width: 150px;
}

.about-inner {
  display: flex;
  justify-content: center;
  /* min-height: 520px; */
  /* background: linear-gradient(180.22deg, #fafcff -2.86%, #f4f9ff 99.8%); */
  background-image: url('@/assets/aboutBg.png');
  background-size: 100% 100%;
  background-repeat: no-repeat;
  /* border-radius: 20px; */
  padding: 0 60px;
}
.about-text {
  background: linear-gradient(180.22deg, rgba(250, 252, 255, 0.8) -2.86%, rgba(244, 249, 255, 0.8) 99.8%);

  border-radius: 20px;
  padding: 50px 150px;
  width: 100%;
  display: flex;
}
.about-text .aboutIcon {
  width: 80px;
  height: 80px;
  margin-right: 20px;
}
.about-text .aboutDetail .title {
  color: #1a41e7;
  font-size: 20px;
  font-weight: 700;
  line-height: 30px;
}
.about-text .aboutDetail .desc {
  color: #333;
  font-size: 16px;
  line-height: 26px;
}
.about-text .aboutDetail .line {
  width: 100%;
  height: 1px;
  background: #d9e0ff;
  margin: 20px 0;
}
.about-text h2 {
  font-size: 22px;
  font-weight: 700;
}

.about-en {
  margin-top: 4px;
  font-size: 12px;
  letter-spacing: 0.18em;
  color: #9ca3af;
}

.about-name {
  margin-top: 16px;
  font-size: 15px;
  font-weight: 600;
}

.about-desc {
  margin-top: 10px;
  font-size: 13px;
  color: #4b5563;
  line-height: 1.8;
  max-width: 480px;
}

.about-image {
  flex: 2;
}

.about-image img {
  width: 100%;
  /* border-radius: 20px; */
  object-fit: cover;
  box-shadow: 0 15px 35px rgba(15, 35, 95, 0.2);
}

/* footer */

.footer {
  margin-top: 16px;
  background: linear-gradient(180.22deg, #fafcff -2.86%, #f4f9ff 99.8%);
  font-size: 12px;
  color: #6b7280;
}

.footer-main {
  display: flex;
  gap: 32px;
  padding: 32px 16px 20px;
}

.footer-col {
  flex: 1;
}

.footer-title {
  font-size: 13px;
  font-weight: 600;
  margin-bottom: 8px;
  color: #111827;
}

.footer-col a {
  display: block;
  margin-bottom: 4px;
  cursor: pointer;
}

.qrcode-wrap {
  display: flex;
  gap: 12px;
}

.qrcode {
  width: 60px;
  height: 60px;
  background: #e5e7eb;
  border-radius: 10px;
}

.footer-bottom {
  text-align: center;
  padding: 8px 16px 16px;
  border-top: 1px solid #e5edff;
  font-size: 11px;
}

/* 顯示/隱藏 PC & Mobile 元素 */
.pc-only {
  display: flex;
}

.mobile-only {
  display: none;
}

/* 動畫 */
.fade-enter-active,
.fade-leave-active {
  transition: opacity 0.15s ease;
}

.fade-enter,
.fade-leave-to {
  opacity: 0;
}

/* ------------------ 響應式 ------------------ */

@media (max-width: 1024px) {
  .hero-inner {
    flex-direction: column;
    align-items: flex-start;
  }
  .hero-graphic {
    margin-top: 24px;
    align-items: flex-start;
  }
  .hero-main-text {
    font-size: 32px;
  }
}

@media (max-width: 768px) {
  .pc-only {
    display: none !important;
  }
  .mobile-only {
    display: flex !important;
  }
  .header-inner {
    height: 56px;
  }

  .hero-inner {
    padding: 40px 16px 32px;
  }
  .hero-text h1 {
    font-size: 22px;
  }
  .hero-sub {
    font-size: 11px;
  }
  .hero-desc {
    font-size: 13px;
  }
  .hero-actions {
    flex-direction: row;
  }
  .hero-graphic {
    align-items: center;
    width: 100%;
  }
  .hero-main-text {
    font-size: 26px;
  }
  .hero-chip {
    width: 180px;
    height: 96px;
  }

  .stats-grid {
    grid-template-columns: repeat(2, minmax(0, 1fr));
    margin-top: 8px;
  }

  .section {
    padding: 32px 0;
  }
  .card-grid {
    grid-template-columns: repeat(2, minmax(0, 1fr));
  }

  .about-inner {
    flex-direction: column;
  }
  .about-desc {
    max-width: none;
  }

  .footer-main {
    flex-direction: column;
  }
}

@media (max-width: 480px) {
  .stats-grid {
    grid-template-columns: 1fr;
  }
  .card-grid {
    grid-template-columns: 1fr;
  }
  .hero-actions {
    flex-direction: column;
    align-items: flex-start;
  }
  .btn-primary,
  .btn-ghost {
    width: 100%;
    text-align: center;
  }
}
</style>
